export const PRIMARY_TZ_ADDRESS_COLOR = 'PRIMARY_TZ_ADDRESS_COLOR'
export const SECONDARY_TZ_ADDRESS_COLOR = 'SECONDARY_TZ_ADDRESS_COLOR'
export type TzAddressStyles = typeof SECONDARY_TZ_ADDRESS_COLOR | typeof PRIMARY_TZ_ADDRESS_COLOR | undefined
